import { apiClient } from '@/services/api-client';
import type { CustomerPortalMenuSettings } from '@/types/customer-portal-menu';
import { normalizePortalMenuItems } from '@/lib/portal-menu';

type ApiPayload = {
  data?: unknown;
  items?: unknown;
};

function normalizeSettings(payload: ApiPayload | undefined): CustomerPortalMenuSettings {
  const record = (payload as Record<string, unknown> | undefined) ?? {};
  const items = normalizePortalMenuItems(record.items ?? record.data);

  return { items };
}

class CustomerPortalMenuService {
  async getMenu(): Promise<CustomerPortalMenuSettings> {
    const response = await apiClient.get<ApiPayload>('/api/v1/customer/portal/menu');
    return normalizeSettings(response.data);
  }
}

export const customerPortalMenuService = new CustomerPortalMenuService();
